var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"md-body-1\">\n<p translate=\"yes\">&#8226; License Plate Transponder (bumper tag) is 1.5 x 8.5 x 0.85 in. in size, is normally placed on the dashboard before driving to the parking area, and is usually recommended for vehicles with metallized windshield. Some of the known vehicles are the BMW, Tesla, Mercedes Benz, Land Rover, Corvette, Acura MDX, Porsche, Ford F150.</p>\n<p translate=\"yes\">&#8226; Window Sticker Transponder is 2.89 x 2.19 x 0.04 in. in size, self-adhesive, fits most vehicle types and must be affixed to your windshield.</p>\n</div>";
var id1="assets/content/media-request.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/assets/content/media-request.html
// module id = 658
// module chunks = 0